__turbopack_context__.v({
  "disclaimer": "InsightQA-module__nZ7rNq__disclaimer",
  "fieldset": "InsightQA-module__nZ7rNq__fieldset",
  "header": "InsightQA-module__nZ7rNq__header",
  "panel": "InsightQA-module__nZ7rNq__panel",
  "question": "InsightQA-module__nZ7rNq__question",
  "thinking": "InsightQA-module__nZ7rNq__thinking",
  "thinkingLabel": "InsightQA-module__nZ7rNq__thinkingLabel",
});
